// This file is part of InvenioRDM
// Copyright (C) 2024 TU Wien.
//
// Invenio-Curations is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import React from "react";
import { Icon } from "semantic-ui-react";

export const RDMCurationIcon = () => <Icon name="eye" className="neutral" />;
